import { extendTailwindMerge } from 'tailwind-merge';

export type ClassValue = string | false | null | undefined;

/** 디자인 토큰이 만든 이름 중 tailwind-merge 가 기본으로 알아보지 못하는 것(tokens.css 와 같게 — 테스트가 검사) */
export const MERGE_SPACING = ['2-5', 'gutter'] as const;
export const MERGE_SHADOW = [
  'card',
  'card-accent',
  'card-strong',
  'chip',
  'drawer',
  'drop',
  'dropdown',
  'halo',
  'modal',
  'popover',
  'subtle',
] as const;

const isTypoName = (value: string) => /^[a-z0-9-]+$/.test(value);

const merge = extendTailwindMerge<'typo'>({
  extend: {
    theme: { spacing: [...MERGE_SPACING], shadow: [...MERGE_SHADOW] },
    classGroups: { typo: [{ typo: [isTypoName] }] },
  },
});

/**
 * 클래스 이름을 이어 붙이고, 겹치는 유틸리티는 뒤의 것만 남긴다(`cn('w-full', 'w-(--size-button-md)')`
 * → 뒤의 너비). 그래서 atom 의 기본 클래스를 쓰는 쪽 `className` 으로 덮어쓸 수 있다.
 * 조건부 클래스는 `cond && 'class'` 로 넘긴다. 클래스 이름 자체를 조립하지 않는다(`bg-${tone}` 금지) — 리터럴 맵을 쓴다.
 */
export function cn(...values: ClassValue[]): string {
  return merge(values.filter((value): value is string => Boolean(value)).join(' '));
}
